import { ExternalLinkIcon, ExternalLinkIconProps, useTranslation } from '@diagentech/exprworks-ui-components';
import React from 'react';

import { TelegramIcon } from '@/components/icons/TelegramIcon';

interface TelegramLinkProps {
  url: ExternalLinkIconProps['url'];
}

export const TelegramLink: React.FC<TelegramLinkProps> = ({ url }) => {
  const ariaLabel = useTranslation('SH.ARIA.TELEGRAMLINK');

  return (
    <ExternalLinkIcon size="large" aria-label={ariaLabel} color="inherit" url={url}>
      <TelegramIcon />
    </ExternalLinkIcon>
  );
};
